import React, { useMemo } from "react";
import Button from "../../button/button.js";
import "../table-options-cell/styles.css";
import DeleteIcon from "../../../icons/delete-icon.js";
import TickIcon from "../../../icons/tick-icon.js";
import DocumentOutlined from "../../../icons/document-outlined.js";
import { useNavigate } from "react-router-dom";
import { useScreen } from "../../../components/Utils/Screens.js";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const TableOptionsCell = (params) => {
  const {
    optionOne,
    optionOneType,
    optionOneDisabled = false,
    optionOneTitle,
    optionTwo,
    optionTwoType,
    optionOneClickPath,
    optionOneClickFn,
    optionTwoClickFn,
    optionTwoClickPath,
    optionThree,
    optionThreeType,
    optionThreeClickPath,
    optionThreeClickFn,
    optionFour,
    optionFourType,
    optionFourClickPath,
    optionFourClickFn,
    rowData,
    moreData,
    type,
    openNewTab = false,
    optionDownloadButton,
    optionDownloadButtonType,
    optionDownloadButtonClickFn,
    optionDownloadButtonLoading,
    optionThreeLinkStateData,
  } = params || {};

  const navigate = useNavigate();

  const isPhone = !useScreen("sm");

  const showOptionOneIcon = useMemo(() => {
    if (optionOneType === "failure" && optionOne !== "Assign") {
      return <DeleteIcon />;
    } else if (optionOneType === "success" && optionOne !== "Add Tracking") {
      return <TickIcon />;
    } else {
      return null;
    }
  }, [optionOneType]);

  const showOptionTwoIcon = useMemo(() => {
    switch (optionTwoType) {
      case "failure":
        return <DeleteIcon />;
      case "success":
        return <TickIcon />;
      default:
        return null;
    }
  }, [optionTwoType]);

  const handleOptionOneClickFn = () => {
    if (typeof optionOneClickFn === "function") {
      optionOneClickFn(rowData);
    } else if (
      optionOneClickPath &&
      (type === "CommissionStatementsDistributor" || rowData)
    ) {
      return navigate(optionOneClickPath, {
        state: {
          ...rowData,
          ...moreData,
        },
      });
    } else if (openNewTab && optionOneClickPath) {
      window.open(optionOneClickPath);
    } else if (optionOneClickPath && !openNewTab) {
      return navigate(optionOneClickPath);
    }
    else if(optionOneClickPath && type === "IVRDetails"){
      return navigate(optionOneClickPath, {
        state: {
          ...moreData,
        },
      });
    }
  };

  const handleOptionTwoClickFn = () => {
    if (typeof optionTwoClickFn === "function") {
      optionTwoClickFn(rowData);
    } else if (optionTwoClickPath && type === "CommissionStatementsDetails") {
      return navigate(optionTwoClickPath, {
        state: {
          ...rowData,
          ...moreData,
        },
      });
    } else if (optionTwoClickPath) {
      return navigate(optionTwoClickPath);
    }
  };

  const handleOptionThreeClickFn = () => {
    if (typeof optionThreeClickFn === "function") {
      optionThreeClickFn(rowData);
    } else if (optionThreeClickPath) {
      return navigate(optionThreeClickPath, {
        state: optionThreeLinkStateData,
      });
      // return navigate(optionThreeClickPath, { type: "Duplicate", data: optionThreeLinkStateData } );
    }
  };

  const handleOptionFourClickFn = () => {
    if (typeof optionFourClickFn === "function") {
      optionFourClickFn(rowData);
    } else if (optionFourClickPath) {
      return navigate(optionFourClickPath);
    }
  };

  const handleOptionDownloadButtonClickFn = () => {
    optionDownloadButtonClickFn(rowData);
  };

  return (
    <div
      className="table-options-cell"
      style={
        isPhone
          ? {
              overflowX: "auto",
              scrollbarWidth: "none",
            }
          : {}
      }
    >
      {optionOne && (
        <Button
          variant="table"
          subVariant={optionOneType}
          icon={showOptionOneIcon}
          className="button-width"
          disabled={optionOneDisabled}
          title={optionOneTitle}
          onClick={handleOptionOneClickFn}
        >
          {optionOne}
        </Button>
      )}
      {optionDownloadButton && (
        <Button
          variant="table"
          subVariant={optionDownloadButtonType}
          disabled={optionDownloadButtonLoading}
          className="button-width"
          onClick={handleOptionDownloadButtonClickFn}
        >
          {optionDownloadButtonLoading ? (
            <>
              <Spin indicator={<LoadingOutlined spin />} />
            </>
          ) : (
            <>
              <DocumentOutlined className="table-button-icon-left" /> Download
            </>
          )}
        </Button>
      )}
      {optionTwo && (
        <Button
          variant="table"
          subVariant={optionTwoType}
          icon={showOptionTwoIcon}
          onClick={handleOptionTwoClickFn}
          className="button-width"
        >
          {optionTwo}
        </Button>
      )}
      {optionThree && (
        <Button
          variant="table"
          subVariant={optionThreeType}
          // icon={showOptionTwoIcon}
          onClick={handleOptionThreeClickFn}
          className="button-width"
        >
          {optionThree}
        </Button>
      )}
      {optionFour && (
        <Button
          variant="table"
          subVariant={optionFourType}
          // icon={showOptionTwoIcon}
          onClick={handleOptionFourClickFn}
          className="button-width"
        >
          {optionFour}
        </Button>
      )}
    </div>
  );
};

export default TableOptionsCell;
